import Api from "./api";

export const getRequestingUserHistory = async (requestingUserId, page = 1, pageSize = 10) => {
  let data = [];
  await Api.get(`/requestinguserhistory/${requestingUserId}?page=${page}&pageSize=${pageSize}`)
    .then((result) => {
      data = result.data;
    })
    .catch((err) => {
      data = err;
    });
  return data;
};
